import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Lock, ArrowRight, GraduationCap } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B192C] text-white relative overflow-hidden grid place-items-center px-4">
      <div className="vk-grain" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-md bg-white/5 border border-white/10 grid place-items-center">
            <GraduationCap size={22} className="text-[#FF6B35]" />
          </span>
          <div className="font-display text-xl font-bold">Vikramshila Classes · Admin</div>
        </Link>
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="rounded-lg border border-white/10 bg-white/5 p-8 backdrop-blur-xl">
          <div className="flex items-center gap-2 text-[#FF6B35]"><Lock size={18} /><span className="text-xs uppercase tracking-widest">Staff login</span></div>
          <h1 className="mt-3 font-display text-3xl font-800">Sign in to continue</h1>
          <p className="mt-2 text-sm text-white/60">Only authorised staff can access this area.</p>

          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email" className="text-white/80">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-white/40" />
            </div>
            <div>
              <Label htmlFor="password" className="text-white/80">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-white/40" />
            </div>
          </div>

          <button type="submit" disabled={loading} data-testid="login-submit" className="vk-btn-primary w-full mt-6 justify-center">
            {loading ? "Signing in…" : (<>Sign In <ArrowRight size={16} /></>)}
          </button>

          <Link to="/" className="mt-6 block text-center text-sm text-white/60 hover:text-white">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
